import React, {useRef} from 'react';
import {CSSTransition} from 'react-transition-group';
import styles from "./styles.module.scss";

interface CustomCssTransitionProps {
  children?: React.ReactNode;
  inProp: boolean;
  withHeight?: boolean;
}

const CustomCssTransition: React.FC<CustomCssTransitionProps> = ({
                                                                   children,
                                                                   inProp,
                                                                   withHeight = false,
                                                                 }) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const transitionClasses = withHeight
    ? {
      enter: styles.heightFadeEnter,
      enterActive: styles.heightFadeEnterActive,
      exit: styles.heightFadeExit,
      exitActive: styles.heightFadeExitActive,
    }
    : {
      enter: styles.fadeEnter,
      enterActive: styles.fadeEnterActive,
      exit: styles.fadeExit,
      exitActive: styles.fadeExitActive,
    };

  return (
    <CSSTransition
      nodeRef={nodeRef}
      timeout={500}
      in={inProp}
      classNames={transitionClasses}
      unmountOnExit
    >
      <div ref={nodeRef}>
        {children}
      </div>
    </CSSTransition>
  );
};

export default CustomCssTransition;